<template>
    <div class="horizontalScreen success mobile-main" type="false">
        <headers_m></headers_m>
        <div class="liveContent" v-if="openlive">
            <div class="leftBox">
                <iframe
                    :src="$t('live').livelink"
                    frameborder="0"
                    width="100%"
                    height="421"
                    scrolling="no"
                    allowfullscreen="true"
                ></iframe>
                <div id="imbottom">
                    <div class="interactive">
                        <div class="lookLive">
                            <img src="../assets/eays.png" class="eays" />
                            <!-- <div class="trex">{{ $t("live").liveNumber }}</div> -->
                            <span>{{ user_live_number }}</span>
                        </div>
                        <div class="niceBox" @click="ranzl()">
                            <img src="../assets/nice.png" class="xnice" />
                            <span>{{ zan }}</span>
                            <div id="emjio" ref="emjio">
                                <p></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="livemenu">
                <div
                    class="inter"
                    :class="toglePPT ? '' : 'intercolor'"
                    @click="toggleMenu($event)"
                    data-ev="true"
                >
                    {{ $t("live").Interaction }}
                </div>
                <div
                    :class="!toglePPT ? '' : 'intercolor'"
                    @click="toggleMenu($event)"
                >
                    PPT
                </div>
            </div>
            <div class="rightBox" :style="{ height: msgBoxHeight + 'px' }">
                <div class="pptBox" v-show="!showInter">
                    <img :src="pptsrc" alt="" class="ppt" @click="biglcik" />
                </div>
                <div id="message" v-show="showInter" @touchend="getPosition">
                    <div
                        class="reply cberr"
                        style="left: -1px"
                        v-show="topmsg.avatar != ''"
                    >
                        <div class="avatarBox" style="margin-top: 3px">
                            <img :src="topmsg.avatar" class="mags" />
                        </div>
                        <div class="item_content">
                            <p class="name">
                                {{ topmsg.nickname }}
                                <span class="Top" v-if="topmsg.is_sticky == 1"
                                    >TOP</span
                                >
                            </p>
                            <div class="yin">{{ topmsg.content }}</div>
                        </div>
                    </div>
                    <scroller
                        :on-refresh="refresh"
                        refresh-layer-color="#fff"
                        ref="scroller"
                        :refreshText="$t('live').downmsg"
                    >
                        <div class="search_cont clearfix">
                            <div
                                :id="'ct' + item.id"
                                class="reply"
                                v-for="(item, index) in historyMsg"
                                :key="index"
                            >
                                <div class="avatarBox">
                                    <img :src="item.avatar" class="mag" />
                                </div>

                                <div class="item_content">
                                    <p class="name">
                                        {{ item.nickname }}
                                        <span
                                            class="Top"
                                            v-if="item.is_sticky == 1"
                                            >TOP</span
                                        >
                                    </p>
                                    <div class="yin">{{ item.content }}</div>
                                </div>
                            </div>
                        </div>
                    </scroller>
                    <div class="xinxx" v-if="newmsg > 0" @click="tobard">
                        {{ newmsg + $t("live").newmsg }}
                    </div>
                </div>
            </div>
            <div id="footer" v-show="showInter">
                <div class="raduisContent">
                    <input
                        class="selfmsg"
                        type="text"
                        :placeholder="says"
                        v-model.trim="Mymsg"
                    />
                    <p class="send" @click="send">{{ $t("live").send }}</p>
                </div>
            </div>
        </div>
        <div class="main" v-if="!openlive">
            <div class="waiting">
                <img
                    src="https://oss.eventnet.cn/H5/mi/waiting_icon.png"
                    alt=""
                />
                <p class="waiting_text">{{ $t("waiting").title }}</p>
            </div>
        </div>
        <bighoto v-bind:items="items" v-if="bigp" @show="close" />
        <toast
            bg_color="rgba(255,105,0,.88)"
            v-bind:msg="msg"
            :intval="intval"
            v-if="toastShow"
            v-on:toastHide="GetStatus"
        ></toast>
    </div>
</template>

<script>
import headers_m from "../components/headers_m.vue";
import { importScript } from "../importScript";
import bighoto from "../components/PhotoSwipe.vue"; //图片放大
export default {
    components: {
        headers_m,
        bighoto,
    },
    name: "mlive",
    data() {
        return {
            lang: "",
            faceShow: false,
            Mymsg: "",
            topmsg: { avatar: "" },
            historyMsg: [],
            historyMsgchange: false,
            ibiu: false,
            scrollTop: 0,
            says: "",
            nosend: false,
            openlive: null,
            pptsrc: "https://oss.eventnet.cn/H5/mi/pc_video_zh.png",
            seg: 1,
            user_live_number: 0,
            intval: 1300,
            lisenter: false,
            wmsg: false,
            msgBoxHeight: 0,
            showInter: true,
            toglePPT: true,
            iedt: 0,
            zan: 0,
            toastShow: false,
            msg: "请输入您的评论",
            bigp: false,
            jiny: false,
            newmsg: -1,
            items: [
                {
                    src: "https://oss.eventnet.cn/H5/pinganMeeting/wt.jpg",
                    w: 2001,
                    h: 1125,
                },
            ],
        };
    },
    created() {
        let lang = localStorage.getItem("lang");
        this.$i18n.locale = this.lang = lang;
    },
    activated() {
        let token = localStorage.getItem("token");
        if (token == "" || token == null) {
            this.$router.replace("/login").catch(() => {});
        }
    },
    mounted() {
        this.openlive = window.opene;
        this.getstcky();
        this.msgBoxHeight = innerHeight - 103 - 414 - 90 - 80 - 85;
        let that = this;
        this.init();
        /* 初始化点赞 */
        if (window.opene) {
            this.$nextTick(() => {
                that.ranzl();
            });
        }

        importScript(
            "https://cdn.aodianyun.com/dms/rop_client.js",
            () => {
                ROP.On("enter_suc", function () {
                    ShowMsg("EnterSuc", "");
                });
                //重连中
                ROP.On("reconnect", function () {
                    ShowMsg("reconnect:");
                });
                //离线状态，之后会重连
                ROP.On("offline", function (err) {
                    ShowMsg("offline:" + err);
                });
                //登陆失败
                ROP.On("enter_fail", function (err) {
                    ShowMsg("EnterFail:" + err);
                });
                //收到消息
                ROP.On("publish_data", function (data, topic) {
                    ShowMsg(topic, data);
                });
                //彻底断线了
                ROP.On("losed", function () {
                    ShowMsg("Losed");
                });

                function ShowMsg(topic, data) {
                    if (topic != "EnterSuc") {
                        let item = JSON.parse(data);
                        console.log(item);
                        console.log(topic);
                        if (item.type == 0) {
                            //接收文字消息显示到页面
                            switch (item.status) {
                                case 1:
                                    if (item.is_sticky == 1) {
                                        that.topmsg = item;
                                        if (that.historyMsg[0].is_sticky == 1) {
                                            that.historyMsg.splice(0, 1);
                                        }
                                        that.historyMsg.unshift(that.topmsg);
                                    } else {
                                        that.historyMsg.push(item);
                                    }
                                    break;
                                case 3: //删除消息
                                    for (
                                        let index = 0;
                                        index < that.historyMsg.length;
                                        index++
                                    ) {
                                        const element = that.historyMsg[index];
                                        if (element.id === item.id) {
                                            that.historyMsg.splice(index, 1);
                                            continue;
                                        }
                                    }
                                    if (that.topmsg.id === item.id) {
                                        that.topmsg = { avatar: "" };
                                    }
                                    break;
                                case 10:
                                    that.user_live_number =
                                        item.user_live_number;
                                    if (item.zan_number > 10000) {
                                        that.zan =
                                            (item.zan_number / 10000).toFixed(
                                                2
                                            ) + "w";
                                    } else {
                                        that.zan = item.zan_number;
                                    }
                                    break;
                                case 11:
                                    that.items[0].src = item.image;
                                    let img = new Image();
                                    img.onload = () => {
                                        that.items[0].w = img.width;
                                        that.items[0].h = img.height;
                                    };
                                    img.src = item.image;
                                    that.pptsrc = item.image;
                                    break;
                            }
                        }
                    } else {
                        console.log("连接成功");
                    }
                }

                function OnEnter() {
                    var num = Math.floor(Math.random() * (1 - 289207) + 289207);
                    ROP.Enter(
                        "pub_ba56a3f93e72296149d9113d513a9656",
                        "sub_7c5e9c9002d0ce11c7848cd28b409756",
                        "suid_" + num,
                        true
                    );
                }

                function OnJoin() {
                    ROP.Subscribe("wx");
                }

                OnEnter();
                OnJoin();
            },
            () => {
                console.log("连接失败");
            }
        );
    },
    computed: {},
    methods: {
        refresh() {
            this.getInitMsg();
        },
        toggleMenu(ev) {
            this.toglePPT = ev.currentTarget.dataset.ev;
            this.showInter = ev.currentTarget.dataset.ev;
        },
        close(e) {
            this.bigp = e;
        },
        biglcik() {
            this.bigp = true;
        },
        init() {
            this.rq
                .post("https://center-service.event1.cn/chat/index", {})
                .then((res) => {
                    //chat_send(全体禁言):1,正常，chat_send：0，禁言
                    console.log(res.data);
                    if (res.code == 1) {
                        this.lisenter = true;
                        if (res.data.chat_send == 0) {
                            this.nosend = true;
                            this.says = this.$t("live").Block;
                        }
                        if (res.data.current_ppt == "") {
                            this.pptsrc =
                                "https://oss.eventnet.cn/H5/mi/pc_video_zh.png";
                            this.items[0].src =
                                "https://oss.eventnet.cn/H5/mi/pc_video_zh.png";
                            let img = new Image();
                            img.onload = () => {
                                this.items[0].w = img.width;
                                this.items[0].h = img.height;
                            };
                            img.src =
                                "https://oss.eventnet.cn/H5/mi/pc_video_zh.png";
                        } else {
                            this.pptsrc = res.data.current_ppt;
                            this.items[0].src = res.data.current_ppt;
                            let img = new Image();
                            img.onload = () => {
                                this.items[0].w = img.width;
                                this.items[0].h = img.height;
                            };
                            img.src = res.data.current_ppt;
                        }
                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        getPosition() {
            setTimeout(() => {
                let scrollheight =
                    document.querySelector("._v-content").offsetHeight -
                    this.msgBoxHeight;
                this.scrollTop = this.$refs.scroller.getPosition().top;
                if (Math.abs(scrollheight - this.scrollTop) < 100) {
                    this.wmsg = true;
                } else {
                    this.wmsg = false;
                }
                console.log(this.wmsg);
                this.newmsg = 0;
            }, 350);
        },
        getInitMsg() {
            this.rq
                .get(
                    `https://center-service.event1.cn/chat/history?limit=8&offset=${this.iedt}&filter={"status":1,"is_sticky":0}&order=desc&sort=createtime`
                )
                .then((res) => {
                    this.$refs.scroller.finishPullToRefresh();
                    if (res.code == 1 && res.data.rows.length != 0) {
                        // if (this.topmsg.is_sticky != null) {
                        //     this.historyMsg.splice(0, 1);
                        // }
                        res.data.rows.reverse();
                        this.historyMsg.unshift(...res.data.rows);
                        // if (this.topmsg.is_sticky != null) {
                        //     this.historyMsg.unshift(this.topmsg);
                        // }
                        this.iedt++;
                    } else if (
                        res.data.rows.length == 0 &&
                        this.historyMsg.length == 0 &&
                        this.topmsg.is_sticky != null
                    ) {
                        // console.log(this.topmsg);
                        // this.historyMsg.unshift(this.topmsg);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        getstcky() {
            this.rq
                .get(
                    `https://center-service.event1.cn/chat/history?limit=1&offset=0&filter={"status":1,"is_sticky":1}&order=desc&sort=updatetime`
                )
                .then((res) => {
                    if (res.code == 1 && res.data.rows.length != 0) {
                        this.topmsg = res.data.rows[0];
                    }
                    this.getInitMsg();
                })
                .catch((err) => {
                    console.log(err);
                    this.getInitMsg();
                });
        },
        toggle(ev) {
            this.faceShow = !this.faceShow;
        },
        send() {
            if (this.Mymsg != "") {
                this.newmsg = 0;
                let data = new FormData();
                data.append("content", this.Mymsg);
                data.append("type", 0);
                this.rq
                    .post("https://center-service.event1.cn/chat/send", data)
                    .then((data) => {
                        console.log(data);
                        if (data.code == 1) {
                            this.jiny = false;
                            let scrollheight =
                                document.querySelector("._v-content")
                                    .offsetHeight - this.msgBoxHeight;
                            this.$refs.scroller.scrollBy(
                                0,
                                scrollheight + 60,
                                true
                            );
                        } else if (data.code == -2) {
                            this.nosend = true;
                            console.log(data.data.bantime);
                            this.says =
                                this.$t("live").Block + data.data.bantime;
                            this.msg = this.$t("live").Block + "....";
                            this.toastShow = true;
                            this.jiny = true;
                        } else if (data.code == 290001) {
                            this.msg = this.$t("live").CommentsUnderReview;
                            this.toastShow = true;
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    });
                this.Mymsg = "";
            } else {
                this.msg = this.$t("live").YourComment;
                this.toastShow = true;
            }
        },
        ranzl() {
            let aaa = 0;
            let epsa = this.$refs.emjio;
            let liag = setInterval(function () {
                aaa++;
                let a = Math.floor(10 * Math.random());
                let div = document.createElement("div");
                div.setAttribute("class", "psap1");
                div.style.backgroundPosition = `-${a * 60}px 0`;
                // div.style.transform = "matrix(0, 0, 0, 0, 0, 0)";
                epsa.appendChild(div);
                div.animate(
                    [
                        {
                            transform: "matrix(0, 0, 0, 0, 0, 0)",
                            opacity: 0.1,
                        },
                        {
                            transform: "matrix(.2, 0, 0, .2, "
                                .concat(10 * Math.random() - 20, ", ")
                                .concat(10 * Math.random() - 50, ")"),
                            opacity: 0.8,
                        },
                        {
                            transform: "matrix(.5, 0, 0, .5, "
                                .concat(10 * Math.random() - 30, ", ")
                                .concat(10 * Math.random() - 50, ")"),
                            opacity: 1,
                        },
                        {
                            transform: "matrix(.8, 0, 0, .8, "
                                .concat(50 * Math.random() - 30, ", ")
                                .concat(10 * Math.random() - 100, ")"),
                            opacity: 1,
                        },
                        {
                            transform: "matrix(1, 0, 0, 1, "
                                .concat(50 * Math.random() - 30, ", ")
                                .concat(10 * Math.random() - 150, ")"),
                            opacity: 0.5,
                        },
                        {
                            transform: "matrix(.5, 0, 0, .5, "
                                .concat(50 * Math.random() - 30, ", ")
                                .concat(10 * Math.random() - 150, ")"),
                            opacity: 0,
                        },
                    ],
                    1500
                );
                setTimeout(function () {
                    epsa.removeChild(div);
                }, 1400);
                if (aaa > 5) {
                    aaa = 0;
                    clearInterval(liag);
                }
            }, 200);
            this.rq
                .get("https://center-service.event1.cn/good/zan")
                .then((res) => {
                    if (res.code == 1) {
                        this.zan = res.data.zan_number;
                        this.user_live_number = res.data.user_live_number;
                        if (res.data.zan_number > 10000) {
                            this.zan =
                                (res.data.zan_number / 10000).toFixed(2) + "w";
                        } else {
                            this.zan = res.data.zan_number;
                        }
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        ToscrollBar() {
            let scrollheight =
                document.querySelector("._v-content").offsetHeight -
                this.msgBoxHeight;
            console.log(this.scrollTop, scrollheight);
            if (this.wmsg) {
                this.$refs.scroller.scrollBy(0, scrollheight + 60, true);
            }
        },
        tobard() {
            let scrollheight =
                document.querySelector("._v-content").offsetHeight -
                this.msgBoxHeight;
            this.$refs.scroller.scrollBy(0, scrollheight + 60, true);
            this.newmsg = 0;
        },
        GetStatus(status) {
            this.toastShow = status;
        },
    },
    updated() {
        if (this.historyMsgchange && this.wmsg) {
            setTimeout(() => {
                this.historyMsgchange = false;
                this.ToscrollBar();
            }, 200);
        } else if (this.historyMsgchange && this.wmsg == false) {
            this.historyMsgchange = false;
            this.newmsg++;
            console.log(this.newmsg);
        }
        if (this.jiny) {
            this.says = this.$t("live").Block;
        } else {
            this.says = this.$t("live").saySome;
        }
    },
    watch: {
        historyMsg() {
            this.historyMsgchange = true;
        },
    },
};
</script>
<style scoped>
.livemenu {
    width: 98%;
    height: 65px;
    border: 1px solid rgba(156, 64, 0, 0.8);
    margin: 60px 0 0 1%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-image: linear-gradient(
        90deg,
        rgb(0, 0, 0) 0%,
        rgb(45, 19, 0) 25%,
        rgb(0, 0, 0) 73%,
        rgb(45, 19, 0) 100%
    );
}

.livemenu > div {
    height: 70%;
    width: calc(50% - 1px);
    text-align: center;
    font-size: 32px;
    font-weight: bold;
    line-height: 45px;
    letter-spacing: 3px;
    color: #ff6900;
}
.inter {
    border-right: 1px solid #b03e00;
    text-transform: uppercase;
}

.liveContent {
    width: 750px;
    height: calc(100vh - 82px);
    margin: 103px auto 0;
    position: fixed;
    top: 0;
    z-index: 0;
}

.leftBox {
    width: 100%;
    height: 414px;
    margin: 0 auto;
    position: relative;
}

.rightBox {
    width: 98%;
    margin: 0 0 0 1%;
    position: relative;
    top: 18px;
}

.pptBox {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
}

.ppt {
    width: 100%;
}

#imbottom {
    position: relative;
    left: 2%;
    bottom: 18px;
    transform-origin: left top;
    width: 96%;
    height: 40px;
    /* background: #000; */
    font-size: 22px;
    color: #fff;
}
#video {
    margin: 1px 0 0 0;
    width: calc(100% - 2px);
}
.ibiu {
    position: absolute;
    font-size: 0.24rem;
    top: -0.1rem;
    left: 50%;
    white-space: nowrap;
    padding: 0.1rem 0.5rem;
    border: 1px dotted aquamarine;
    background: rgba(160, 229, 201, 0.85);
    border-radius: 0.2rem;
    transform: translate(-50%, -100%);
}

#message {
    height: 100%;
    background-color: #000;
    position: relative;
    overflow: hidden;
    top: 0;
    /* border: 1px solid rgba(204, 204, 204, 0.7); */
    overscroll-behavior: contain;
}

#messageBox {
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    height: 100%;
    padding: 0 10px;
}

#messageBox::-webkit-scrollbar {
    display: none;
}

#footer {
    height: 95px;
    background-color: #000;
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
}
.raduisContent {
    width: 96%;
    height: 60px;
    display: flex;
    margin-left: 2%;
    align-items: center;
    border-radius: 30px;
    border: 1px solid rgba(176, 62, 0, 0.8);
    justify-content: space-around;
}

.selfmsg {
    width: 700px;
    height: 50px;
    background: transparent;
    padding: 0 20px;
    line-height: 0.55rem;
    font-size: 24px;
    caret-color: #b03e00;
    color: #fff;
}

.send {
    height: 50px;
    color: #fff;
    line-height: 50px;
    width: 150px;
    text-align: center;
    border-radius: 30px;
    position: relative;
    font-size: 24px;
    padding: 0 40px;
    margin-right: 3px;
    background-image: linear-gradient(
        90deg,
        rgb(255, 105, 0) 0%,
        rgb(204, 34, 0) 100%
    );
}

.reply {
    margin-bottom: 50px;
    margin-top: 20px;
    width: 94%;
    margin-left: 3%;
    position: relative;
    display: flex;
}

.avatarBox {
    width: 60px;
    height: 60px;
    /* border-radius: 30px; */
    overflow: hidden;
}

.mag {
    width: 60px;
    /* -webkit-clip-path: circle(50% at 30px 30px);
    clip-path: circle(50% at 30px 30px); */
}
.mags {
    width: 60px;
}

.reply .item_content {
    position: relative;
    top: 5px;
    left: 10px;
    flex: 1;
    width: 100%;
    color: #555;
    font-size: 22px;
    line-height: 18px;
}

.reply .item_content .name {
    color: #afafaf;
    font-size: 20px;
    margin-bottom: 10px;
}

.xinxx {
    position: absolute;
    top: 0;
    padding: 6px 25px;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 20px;
    color: #fff;
    background: rgba(85, 85, 85, 0.6);
    font-size: 22px;
    text-align: center;
    letter-spacing: 3px;
    z-index: 10025;
}

.yin {
    background-color: rgba(255, 102, 0, 0.15);
    padding: 12px 30px 11px;
    border-radius: 5px;
    color: #fff;
    font-size: 26px;
    display: inline-block;
    word-break: break-all;
    max-width: 90%;
    line-height: 1.5;
}

.interactive {
    width: 99%;
    position: absolute;
    top: 10px;
    left: 0;
    height: 60px;
    /* border: 1px solid #b03e00; */
    display: flex;
    justify-content: space-between;
}
.interactive > div {
    height: 100%;
    position: relative;
    display: flex;
    align-items: center;
}
.eays {
    margin: 0 15px;
    position: relative;
    top: 0;
}
.xnice {
    margin: 0 15px;
    position: relative;
    top: -2px;
}
.xnice + span {
    display: inline-block;
    width: 50px;
}
.intercolor {
    color: #fff !important;
}
#emjio {
    position: relative;
    top: -10px;
    left: -80px;
    pointer-events: none;
}
.FILTER {
    filter: brightness(50%);
}
.Top {
    display: inline-block;
    font-size: 18px;
    width: 60px;
    text-align: center;
    line-height: 24px;
    height: 24px;
    background: #ff6900;
    color: #fff;

    border-radius: 3px;
}
.cberr {
    background: #000 !important;
    z-index: 100;
    top: -22px;
    padding-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/live.vue